export default {
  GET_CACHE_KEY: '_cache',
  ORDER_CLASSIFIED_AD_PREMIUM_UPGRADE: 'frontoffice_order_classified_ad_premium_upgrade',
  PRIVACY: 'frontoffice_static_privacy',
  TERMS_AND_CONDITIONS: 'frontoffice_static_terms',
  LOGIN: 'login',
  CONTACT: 'frontoffice_static_contact_us',
  HOMEPAGE: 'frontoffice_homepage',
};
